<!-- 我的竞猜 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" width="32" alt=""></div>
  
        <div class="title-text">
            <div class="main"><img :src="require('../assets/my-think1.png')" alt="" height="24"></div>
            <div class="subf">竞猜仅为90分钟；比赛结束后即时开盘。</div>
        </div>
        <ul class="list" v-loading="pageLoading">
            <li v-for="item in list " :key="item.id">
              
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">{{item.title}}</div>
                        <div class="cont integral win" v-if="item.status==0">待揭晓</div>
                        <div class="cont integral win" v-else-if="item.status == 1">竞猜胜利</div>
                        <div class="cont integral default" v-else-if="item.status == 2">竞猜失败</div>
                    </div>
                    <div class="desc win ">{{item.content}}</div>
                </div>
            
            </li>
            <!-- <li>
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">11月02日 法国 VS 澳大利亚</div>
                        <div class="cont integral win">竞猜胜利</div>
                    </div>
                    <div class="desc win ">11月21日法国 VS 澳大利亚</div>
                </div>
            </li>
            <li>
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">11月02日 法国 VS 澳大利亚</div>
                        <div class="cont integral default">竞猜失败</div>
                    </div>
                    <div class="desc ">11月21日法国 VS 澳大利亚</div>
                </div>
            </li> -->
        </ul>
    </div>
</el-dialog>
</template>
<script>
/*  status 0 待开盘  1 赌赢   2 赌输 */
export default {
    name :'MyGuessing',
    props:['status'],
    data(){
        return {
            pageLoading:false,
            list:[]
        }
    },
    created(){
       
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        },
        async getList(){
            this.pageLoading = true;
            let result = await this.$axios.get('/worldcup2022/game/coin/my/stake/list');
            this.pageLoading = false;
            console.log('竞猜列表----->',result);
            this.list = result.data.stakes;
        }

    },
    watch:{
        status(val){
            if(val){
                this.getList();
            }
        }
    }

}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:380px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; background-size: 100%; padding:15px; position: relative; border-radius: 10px;
    .title-text{
         padding: 5px 0 19px;
        .main{margin-bottom: 5px;}
        .subf{font-size: 12px; line-height: 18px; color: #fff; opacity: 0.6;}
    }
    .win-cup{position: absolute; right: 70px; top: -31px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.list{
    padding:30px 12px 10px; background: #fff; border-radius: 10px; max-height: 480px; overflow-y:auto;
    li{
        display: flex; align-items: flex-start; max-height: 480px; padding-bottom: 12px; margin-bottom: 15px; border-bottom: 1px solid #eee;
        .tag{margin-right: 15px;}
        .result{font-size: 14px; line-height: 20px; font-weight: 600;}
        .integral{
            font-size: 14px; line-height: 20px; font-weight: 500;
            &.win{color: #FF5108;}
            &.default{color: #00AA5E;}
        }
        .desc{font-size: 12px; line-height: 18px; color: #999;}
    }
}
</style>